<div class="card-container">
    <fluent-card class="check-summary">
        <div class="card-header">
            <div>Renewal <i class="far fa-file-signature"></i></div>
        </div>

        <div class="card-content">
            <div class="card-content-column">
                <div class="three-column-layout">
                    <label>Expiring:</label><div>{{statistics()?.totalCount}}</div><div></div>
                    <label>Renewed:</label><div>{{statistics()?.renewedCount}}</div><div>({{renewedRate() | percent }})</div>
                    <label>Lost/Cancelled:</label><div>{{statistics()?.lostCancelledCount}}</div><div>({{lostCancelledRate() | percent }})</div>
                </div>
            </div>
            <div class="card-content-subtitle">
                Renewal status counts
            </div>
        </div>
    </fluent-card>

    <fluent-card class="check-summary">
        <div class="card-header">
            <div>Status <i class="far fa-traffic-light-go"></i></div>
        </div>

        <div class="card-content">
            <wj-flex-chart #renewalCountsBarChart [bindingX]="'name'" [chartType]="Wijmo.ChartType.Bar"
                           [itemFormatter]="GeneraliBarChartPaletteItemFormatter" [plotMargin]="'10 30 30 120'">
                <wj-flex-chart-legend [position]="Wijmo.Position.None"></wj-flex-chart-legend>
                <wj-flex-chart-axis wjProperty="axisX" [position]="Wijmo.Position.Bottom"
                                    [minorGrid]="true" [majorGrid]="true" [minorUnit]="25" [majorUnit]="50"></wj-flex-chart-axis>
                <wj-flex-chart-axis wjProperty="axisY" [position]="Wijmo.Position.Top" [majorGrid]="false"></wj-flex-chart-axis>
                <wj-flex-chart-series name="Counts" binding="count" ></wj-flex-chart-series>

                <wj-flex-chart-data-label content="{count:n}" [position]="Wijmo.LabelPosition.Right"
                                          [offset]="0"></wj-flex-chart-data-label>
            </wj-flex-chart>
            <div class="card-content-subtitle">
                Current counts by status
            </div>
        </div>
    </fluent-card>

    <fluent-card class="check-summary">
        <div class="card-header">
            <div>GWP <i class="far fa-circle-euro"></i></div>
        </div>

        <div class="card-content">
            <wj-flex-chart [bindingX]="'category'" [itemsSource]="chartData" [itemFormatter]="GeneraliColumnChartPaletteItemFormatter">
                <wj-flex-chart-legend [position]="Wijmo.Position.None"></wj-flex-chart-legend>
                <wj-flex-chart-axis wjProperty="axisY" [position]="Wijmo.Position.None"></wj-flex-chart-axis>
                <wj-flex-chart-axis wjProperty="axisX" [position]="Wijmo.Position.Bottom" [labelAngle]="0"></wj-flex-chart-axis>
                <wj-flex-chart-series name="Premium" binding="amount"></wj-flex-chart-series>

                <wj-flex-chart-data-label content="{amount:n,,0}m" [position]="Wijmo.LabelPosition.Bottom"></wj-flex-chart-data-label>
            </wj-flex-chart>
            <div class="card-content-subtitle">
                Gross written premium expiring versus renewed
            </div>
        </div>
    </fluent-card>

    <fluent-card class="check-summary">
        <div class="card-header">
            <div>LR Delta Δ</div>
        </div>

        <div class="card-content">
            <wj-flex-chart #deltasBarChart [bindingX]="'name'" [chartType]="Wijmo.ChartType.Bar"
                           [plotMargin]="'10 30 30 120'" [itemFormatter]="GeneraliBarChartPaletteItemFormatter">
                <wj-flex-chart-legend [position]="Wijmo.Position.None"></wj-flex-chart-legend>
                <wj-flex-chart-axis wjProperty="axisX" [position]="Wijmo.Position.Bottom"
                                    [minorGrid]="true" [majorGrid]="true" [minorUnit]="25" [majorUnit]="50"></wj-flex-chart-axis>
                <wj-flex-chart-axis wjProperty="axisY" [position]="Wijmo.Position.Top" [majorGrid]="false"></wj-flex-chart-axis>
                <wj-flex-chart-series name="ΔLR" binding="value" ></wj-flex-chart-series>

                <wj-flex-chart-data-label content="{value:p1}" [position]="Wijmo.LabelPosition.Center"
                                          [offset]="0"></wj-flex-chart-data-label>
            </wj-flex-chart>
            <div class="card-content-subtitle">
                LR delta plan to actual
            </div>
        </div>
    </fluent-card>


    <fluent-card class="check-summary">
        <div class="card-header">
            <div>Calculated <i class="far fa-bucket"></i></div>
        </div>

        <div class="card-content" style="justify-content: stretch; align-items: stretch;">
            <wj-flex-pie #bucketPieChart [bindingName]="'name'" [binding]="'count'" [plotMargin]="10"
                         [palette]="GeneraliPieChartPalette" [innerRadius]="0.5"
                         (dblclick)="onChartClick('calculatedPilStatus', bucketPieChart, $event)">
                <wj-flex-chart-legend [position]="Wijmo.Position.Bottom"></wj-flex-chart-legend>
                <wj-flex-pie-data-label content="{count}" [border]="false" [offset]="-25"
                                        [position]="Wijmo.PieLabelPosition.Inside"></wj-flex-pie-data-label>
            </wj-flex-pie>
            <div class="card-content-subtitle">
                Account tiering as calculated
            </div>
        </div>
    </fluent-card>

    <fluent-card class="check-summary">
        <div class="card-header">
            <div>Final <i class="far fa-bucket"></i></div>
        </div>

        <div class="card-content" style="justify-content: stretch; align-items: stretch;" >
            <wj-flex-pie #bucketFinalPieChart [bindingName]="'name'" [binding]="'count'" [plotMargin]="10"
                         [palette]="GeneraliPieChartPalette" [innerRadius]="0.5"
                         (dblclick)="onChartClick('finalPilStatus', bucketFinalPieChart, $event)">
                <wj-flex-chart-legend [position]="Wijmo.Position.Bottom"></wj-flex-chart-legend>
                <wj-flex-pie-data-label content="{count}" [border]="false" [offset]="-25"
                                        [position]="Wijmo.PieLabelPosition.Inside"></wj-flex-pie-data-label>
            </wj-flex-pie>
            <div class="card-content-subtitle">
                Account tiering after manual override
            </div>
        </div>
    </fluent-card>

    <fluent-card class="check-summary">
        <div class="card-header">
            <div>ATS <i class="far fa-bar-chart"></i></div>
        </div>

        <div class="card-content">
            <wj-flex-chart #atsHistogramChart [bindingX]="'name'" [plotMargin]="'18 0 90 70'"
                           [itemFormatter]="GeneraliColumnChartPaletteItemFormatter"
                           (dblclick)="onChartClick('scoreAts', atsHistogramChart, $event)">
                <wj-flex-chart-legend [position]="Wijmo.Position.None"></wj-flex-chart-legend>
                <wj-flex-chart-axis wjProperty="axisY" [position]="Wijmo.Position.None"></wj-flex-chart-axis>
                <wj-flex-chart-axis wjProperty="axisX" [position]="Wijmo.Position.Bottom" [labelAngle]="-45"></wj-flex-chart-axis>
                <wj-flex-chart-series name="Count" binding="count"></wj-flex-chart-series>

                <wj-flex-chart-data-label content="{count:n}" [position]="Wijmo.LabelPosition.Top"></wj-flex-chart-data-label>
            </wj-flex-chart>
            <div class="card-content-subtitle">
                ATS Histogram (higher is better)
            </div>
        </div>
    </fluent-card>
</div>
